/* Mantelly gift finder (sections/mt-gift-finder.liquid, 29/09).
   Dados: #mtgf-map (respostas de cada produto, gerado por loja/_build/gift_finder_data.py) + #mtgf-live (Liquid, na moeda
   do visitante: variante padrão da escada, rótulo da oferta, preço, "de", nível 1 e foto limpa).
   Pontuação: 4 x para quem + 3 x interesse + orçamento + bônus (best seller, card da home).
     - para quem: 1 com a tag; Her/Him dão 0,5 a produto neutro (sem tag de pessoa, ou só Secret Santa); Anyone dá 0,5 a todos;
       Kids, Pet e Faith põem primeiro os produtos com a tag (os outros só completam os 3 cards);
     - orçamento (preço do nível 1): na faixa 3; mais barato 2 (uma faixa) ou 1 (duas); mais caro 1 (uma faixa) ou 0 (duas);
       "Above your budget" só quando é mais caro; "Their perfect gift" = pessoa + interesse + dentro do orçamento (ou abaixo).
   Orçamento: US$30 e US$60 convertidos por Shopify.currency.rate e arredondados para cima (5 abaixo de 100, 10 abaixo de
   1000), comparados com o preço do nível 1 na moeda do visitante.
   Comprar: window.hcAddToCart (assets/hc-cart-open.js) com a variante padrão. Compra direta (dono, 07/10): o botão é
   "Buy now" e o add vai direto para o checkout (snippets/mt-direct-checkout.liquid); com a configuração desligada, abre a gaveta.
   Privacidade: nada vai para analytics; as respostas ficam só na URL do resultado. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mtgf]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function read(id) {
    try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return null; }
  }

  var MAP = read('mtgf-map') || {};
  var LIVE = read('mtgf-live') || [];
  var P = LIVE.filter(function (p) { return p && MAP[p.h]; }).map(function (p) {
    var m = MAP[p.h];
    return Object.assign({}, p, { w: m.w || [], i: m.i || [], b: +m.b || 0, bs: !!m.bs, o: +m.o || 0 });
  });

  /* ---------- orçamento na moeda do visitante ---------- */
  var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  function nice(n) {
    var step = n < 20 ? 1 : n < 100 ? 5 : n < 1000 ? 10 : 100;
    return Math.ceil(n / step - 1e-9) * step;
  }
  var T1 = nice(30 * rate), T2 = nice(60 * rate); // unidades da moeda
  var sample = root.dataset.money || '$1';
  function fmt(n) { return /1(?!\d)/.test(sample) ? sample.replace(/1(?!\d)/, String(n)) : String(n); }
  var BUDGET = { low: 'Under ' + fmt(T1), mid: fmt(T1) + '–' + fmt(T2), high: fmt(T2) + '+' };
  $$('[data-mtgf-budget]').forEach(function (el) { el.textContent = BUDGET[el.dataset.mtgfBudget]; });
  var TIERS = ['low', 'mid', 'high'];
  function tierOf(cents) { return cents < T1 * 100 ? 0 : cents < T2 * 100 ? 1 : 2; }
  var GOAL = +root.dataset.goal || 0; // frete grátis a partir de (centavos da moeda); 0 = sem frete grátis (CH/NO)

  /* ---------- rótulos ---------- */
  var WHO = { her: 'For her', him: 'For him', kids: 'For kids', pet: 'For a pet', faith: 'Faith gift', any: 'Secret Santa' };
  var INTO = { cozy: 'Cozy nights', funny: 'Funny', tech: 'Tech & lights', decor: 'Christmas decor', kitchen: 'Coffee & kitchen' };
  var STEPS = ['who', 'into', 'budget'];

  /* ---------- pontuação ---------- */
  var PEOPLE = ['her', 'him', 'kids', 'pet', 'faith'];
  var STRICT = { kids: 1, pet: 1, faith: 1 };
  function score(p, a) {
    var whoS;
    if (p.w.indexOf(a.who) > -1) whoS = 1;
    else if (a.who === 'any') whoS = 0.5;
    else if ((a.who === 'her' || a.who === 'him') && !p.w.some(function (x) { return PEOPLE.indexOf(x) > -1; })) whoS = 0.5;
    else whoS = 0;
    var intoS = p.i.indexOf(a.into) > -1 ? 1 : 0;
    var d = tierOf(p.onec) - TIERS.indexOf(a.budget); // > 0 = mais caro que o orçamento
    var bud = d === 0 ? 3 : d === -1 ? 2 : d === -2 ? 1 : d === 1 ? 1 : 0;
    return { p: p, s: 4 * whoS + 3 * intoS + bud + p.b, who: whoS === 1, into: intoS === 1, ok: d <= 0, over: d > 0 };
  }
  function byScore(x, y) { return y.s - x.s || x.p.o - y.p.o; }

  function pick(a) {
    var ranked = P.map(function (p) { return score(p, a); }).sort(byScore);
    if (STRICT[a.who]) {
      ranked = ranked.filter(function (r) { return r.who; }).concat(ranked.filter(function (r) { return !r.who; }));
    }
    var pool = ranked.filter(function (r) { return r.ok && (r.who || r.into); });
    if (pool.length || (STRICT[a.who] && ranked.length && ranked[0].who)) {
      var t0 = ranked[0];
      return { mode: t0.who && t0.into && t0.ok ? 'perfect' : 'top', list: ranked.slice(0, 3) };
    }
    // nada combina: best sellers (os que cabem no orçamento primeiro)
    var bs = ranked.filter(function (r) { return r.p.bs; }).sort(function (x, y) { return (y.ok - x.ok) || x.p.o - y.p.o; });
    var list = bs.slice(0, 3);
    ranked.forEach(function (r) { if (list.length < 3 && list.indexOf(r) < 0) list.push(r); });
    return { mode: 'fallback', list: list };
  }

  /* ---------- cards ---------- */
  function card(r, main, a) {
    var p = r.p;
    var sizes = main ? '(min-width: 990px) 480px, calc(100vw - 32px)' : '(min-width: 990px) 200px, (min-width: 750px) 30vw, 46vw';
    var tags = [];
    if (p.lab) tags.push('<span class="mtgf-offer">' + esc(p.lab) + '</span>');
    if (main && GOAL > 0 && p.pc >= GOAL) tags.push('<span class="mtgf-chip">Free shipping</span>');
    if (a && r.over) tags.push('<span class="mtgf-chip mtgf-chip--over">Above your budget</span>');
    var price = '<span class="mtgf-now">' + esc(p.p) + '</span>' +
      (p.c ? '<s><span class="visually-hidden">Regular price</span>' + esc(p.c) + '</s>' : '') +
      (p.s ? '<span class="mtgf-save">Save ' + esc(p.s) + '</span>' : '');
    var one = !p.ch && p.ov && p.ov !== p.v && p.onec < p.pc
      ? '<button type="button" class="mtgf-one" data-mtgf-add="' + p.ov + '">' + (main ? 'Or buy just 1 for ' : 'Or just 1 for ') + esc(p.one) + '</button>' : '';
    var buy = p.ch
      ? '<a class="button mtgf-add" href="' + esc(p.u) + '">Choose size</a>'
      : '<button type="button" class="button mtgf-add" data-mtgf-add="' + p.v + '"' + (p.a ? '' : ' disabled') + '>' +
        (p.a ? 'Buy now' : 'Sold out') + '</button>';
    return '<article class="mtgf-card' + (main ? ' mtgf-card--main' : '') + '">' +
      '<a class="mtgf-card__img' + (p.fit === 'contain' ? ' is-contain' : '') + '" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
      '<img src="' + esc(p.img) + '" srcset="' + esc(p.img2) + ' 300w, ' + esc(p.img) + ' 600w, ' + esc(p.img3) + ' 900w" sizes="' + sizes +
      '" width="600" height="600" alt="' + esc(p.t) + '"' + (main ? ' fetchpriority="high"' : ' loading="lazy"') + '></a>' +
      '<div class="mtgf-card__body">' +
      (tags.length ? '<p class="mtgf-tags">' + tags.join('') + '</p>' : '') +
      (main ? '<h3' : '<h4') + ' class="mtgf-card__t"><a href="' + esc(p.u) + '">' + esc(p.t) + '</a>' + (main ? '</h3>' : '</h4>') +
      '<p class="mtgf-price">' + price + '</p>' +
      '<div class="mtgf-buy">' + buy + one + '<a class="mtgf-more" href="' + esc(p.u) + '">See details</a></div>' +
      (main ? '<div data-mtgf-cutslot></div>' : '') +
      '</div></article>';
  }

  /* ---------- telas ---------- */
  var answers = {};
  var current = null;
  var bar = $('[data-mtgf-bar]');
  var count = $('[data-mtgf-count]');
  var back = $('[data-mtgf-back]');
  var top = $('[data-mtgf-top]');

  function url(step, a) {
    if (step !== 'result') return location.pathname;
    return location.pathname + '?for=' + encodeURIComponent(a.who) + '&into=' + encodeURIComponent(a.into) + '&budget=' + encodeURIComponent(a.budget);
  }

  function show(step, how, quiet) {
    current = step;
    $$('.mtgf-step').forEach(function (s) { s.hidden = s.dataset.step !== step; });
    var n = STEPS.indexOf(step);
    var isRes = step === 'result';
    top.hidden = isRes;
    root.classList.toggle('is-res', isRes);
    bar.hidden = isRes;
    if (!isRes) {
      bar.setAttribute('aria-valuenow', String(n + 1));
      bar.style.setProperty('--mtgf-p', ((n + 1) / 3 * 100).toFixed(1) + '%');
      count.textContent = 'Question ' + (n + 1) + ' of 3';
      back.hidden = n === 0;
      $$('[data-step="' + step + '"] [data-q]').forEach(function (b) {
        b.setAttribute('aria-pressed', answers[b.dataset.q] === b.dataset.v ? 'true' : 'false');
      });
    } else {
      render();
    }
    if (how === 'push') history.pushState({ mtgf: step, a: answers }, '', url(step, answers));
    else if (how === 'replace') history.replaceState({ mtgf: step, a: answers }, '', url(step, answers));
    if (how && !quiet) {
      var h = $('[data-step="' + step + '"] .mtgf-h');
      if (h) h.focus({ preventScroll: true });
      var y = root.getBoundingClientRect().top;
      if (y < 0 || y > innerHeight * 0.5) window.scrollTo({ top: Math.max(0, y + scrollY - 96), behavior: 'auto' });
    }
  }

  function render() {
    var a = answers;
    var res = pick(a);
    var t = { perfect: 'Their perfect gift', top: 'Our top pick for them', fallback: 'Our best sellers' }[res.mode];
    $('[data-mtgf-rtitle]').textContent = t;
    $('[data-mtgf-recap]').textContent = [WHO[a.who], INTO[a.into], BUDGET[a.budget]].join(' · ');
    var sub = $('[data-mtgf-rsub]');
    sub.hidden = res.mode !== 'fallback';
    sub.textContent = res.mode === 'fallback' ? 'No exact match for that combo, so here are our best sellers.' : '';
    var list = res.list;
    if (!list.length) {
      $('[data-mtgf-rtitle]').textContent = 'Our best sellers';
      sub.hidden = false;
      sub.innerHTML = 'We couldn&rsquo;t load the picks right now. <a href="/collections/best-sellers">Shop our best sellers</a>.';
    }
    $('[data-mtgf-main]').innerHTML = list[0] ? card(list[0], true, res.mode === 'fallback' ? null : a) : '';
    $('[data-mtgf-alts]').innerHTML = list.slice(1).map(function (r) { return card(r, false, res.mode === 'fallback' ? null : a); }).join('');
    $('[data-mtgf-alth]').hidden = list.length < 2;
    var tpl = $('template[data-mtgf-cut]');
    var slot = $('[data-mtgf-cutslot]');
    if (tpl && slot) slot.innerHTML = tpl.innerHTML;
  }

  function next() {
    var i = STEPS.indexOf(current);
    // seguranca: nunca abre o resultado com resposta faltando
    var miss = STEPS.filter(function (s) { return !answers[s]; })[0];
    show(i < STEPS.length - 1 ? STEPS[i + 1] : (miss || 'result'), 'push');
  }

  function restart() {
    answers = {};
    show('who', 'push');
  }

  async function add(btn) {
    var id = Number(btn.dataset.mtgfAdd);
    var box = btn.closest('.mtgf-card__body');
    var old = box && box.querySelector('.mtgf-err');
    if (old) old.remove();
    if (typeof window.hcAddToCart !== 'function') {
      var f = document.createElement('form');
      f.method = 'post';
      f.action = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add';
      f.innerHTML = '<input type="hidden" name="id" value="' + id + '"><input type="hidden" name="quantity" value="1">' +
        (window.mtDC && !window.mtDirectCheckoutOff ? '<input type="hidden" name="return_to" value="/checkout">' : '');
      document.body.appendChild(f);
      f.submit();
      return;
    }
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = window.mtDC && !window.mtDirectCheckoutOff ? 'Going to checkout…' : 'Adding…';
    try {
      await window.hcAddToCart([{ id: id, quantity: 1 }]);
    } catch (e) {
      var p = document.createElement('p');
      p.className = 'mtgf-err';
      p.setAttribute('role', 'alert');
      p.textContent = (e && e.message) || 'This item could not be added. Please try again.';
      if (box) box.appendChild(p);
    } finally {
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
    }
  }

  root.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-q]');
    if (opt) {
      // so vale o toque na pergunta que esta na tela; o 2o toque rapido (ou a troca Her -> Him) e ignorado
      var from = opt.closest('.mtgf-step').dataset.step;
      if (from !== current || root.dataset.busy) return;
      root.dataset.busy = '1';
      answers = Object.assign({}, answers);
      answers[opt.dataset.q] = opt.dataset.v;
      $$('[data-step="' + from + '"] [data-q]').forEach(function (b) { b.setAttribute('aria-pressed', b === opt ? 'true' : 'false'); });
      // o toque aparece antes de trocar a tela; a trava segue 300 ms depois, para o toque fantasma nao cair na pergunta seguinte
      setTimeout(function () {
        try { if (current === from) next(); }
        finally { setTimeout(function () { delete root.dataset.busy; }, 300); }
      }, 140);
      return;
    }
    if (e.target.closest('[data-mtgf-back]')) {
      if (history.state && history.state.mtgf && STEPS.indexOf(history.state.mtgf) > 0) history.back();
      else show(STEPS[Math.max(0, STEPS.indexOf(current) - 1)], 'replace');
      return;
    }
    if (e.target.closest('[data-mtgf-restart]')) { restart(); return; }
    var b = e.target.closest('[data-mtgf-add]');
    if (b && !b.disabled && b.getAttribute('aria-busy') !== 'true') add(b);
  });

  window.addEventListener('popstate', function (e) {
    var st = e.state;
    if (st && st.mtgf) {
      answers = st.a || {};
      show(st.mtgf, null);
      var h = $('[data-step="' + st.mtgf + '"] .mtgf-h');
      if (h) h.focus({ preventScroll: true });
    }
  });

  /* ---------- entrada ---------- */
  function valid(a) { return WHO[a.who] && INTO[a.into] && BUDGET[a.budget]; }
  var q = new URLSearchParams(location.search);
  var fromUrl = { who: q.get('for'), into: q.get('into'), budget: q.get('budget') };
  var st = history.state;
  if (valid(fromUrl)) {
    answers = fromUrl;
    show('result', 'replace', true);
  } else if (st && st.mtgf && (st.mtgf === 'who' || (st.a && st.a.who))) {
    answers = st.a || {};
    show(st.mtgf === 'result' && !valid(answers) ? 'who' : st.mtgf, null);
  } else {
    show('who', null);
    history.replaceState({ mtgf: 'who', a: {} }, '', location.pathname + location.search);
  }
  root.classList.add('is-ready');
})();
